module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-800.8399f7fa.svg";